import React from 'react'

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Image } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import styled from 'styled-components'

import {
    UpperHeader,
    devices,
    colors,
    // Container,
    // UnstyledLink,
} from '../../Common'

export const Instagram = ({ slides }) => {
    const slidesToShow = 4
    return (
        <CarouselContainer>
            <ImageLayer>
                {/* Make clickable? */}
                <CarouselHeader marginbottom={30} fontSize={23}>@artattackeventco</CarouselHeader>
                <StyledCarouselProvider
                    totalSlides={slides.length}
                    visibleSlides={slidesToShow}
                    dragEnabled={false}
                    step={slidesToShow}
                    // mobile={mobile ? 1 : 0}
                    isIntrinsicHeight={true}
                >
                    <Previous />
                    <SliderWrap>
                        {slides.map((slide, i) => (
                            <Slide key={i} index={i}>
                                <StyledImage key={slide.image} src={slide.image} alt={slide.alt_text} />
                            </Slide>
                        ))}
                    </SliderWrap>
                    <Next />
                </StyledCarouselProvider>
            </ImageLayer>
        </CarouselContainer>
    )
}

const SliderWrap = styled(Slider)`
    div,ul,li {
        outline: none !important;
    }
`

const CarouselHeader = styled(UpperHeader)`
    margin-left: 5.5%;
    margin-bottom: 30px;
    color: ${colors.white} !important;
`

const CarouselContainer = styled.div`
    background-color: ${colors.black};
`

const ImageLayer = styled.div`
    background: url('/static/images/instagram_bg.png') center/cover no-repeat;
    padding: 60px;
`

const StyledImage = styled(Image)`
    border: 10px solid white;
`

const StyledCarouselProvider = styled(CarouselProvider)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    .carousel__slider--horizontal {
        /* margin-left: -10px;
        margin-right: -10px; */
        flex: 0 1 90%;

        .carousel__inner-slide {
            padding-left: 10px;
            padding-right: 10px;
        }

        @media ${devices.small} {
            margin: 0 0 20px;
            .carousel__inner-slide {
                padding: 0;
            }
        }
    }

    .carousel__next-button,
    .carousel__back-button {
        /* position: absolute;
        top: 45%; */
        border: none;
        z-index: 1;
        outline: none !important;
        &:disabled {
            opacity: 0;
            /* display: none; */
            cursor: default;
        }
    }

    .carousel__back-button {
        transform: rotate(180deg);
    }

    .carousel__next-button {
        right: 0;
    }
    
`

const Previous = styled(ButtonBack)`
    width: 35px;
	height: 31px;
    background: url('/static/images/sprite.svg') no-repeat -77px -10px;

    @media ${devices.small} {
        background-position: -376px -312px;
    }
`

const Next = styled(ButtonNext)`
    width: 35px;
	height: 31px;
    background: url('/static/images/sprite.svg') no-repeat -77px -10px;

    @media ${devices.small} {
        background-position: -376px -312px;
    }
`